module.exports = __webpack_public_path__ + "static/img/guide-bg.5345327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome/guide-bg.jpg
// module id = tKcp
// module chunks = 2